import './global/atr-core-constants.js';
import './global/atr-core-lib.js';

import platformApi from './modules/platform';
import financeApi from './modules/finance';


const api = {
	platform: {
		...platformApi
	},
	finance: {
		...financeApi
	}
};

export default api;
